module.exports = __webpack_public_path__ + "img/export.33c85535.svg";